import { useQuery } from "@tanstack/react-query";
import { adaptCarouselBanners } from "src/features/vendorSponsorship/adapters/adaptCarouselBanners";
import cmsClient from "src/services/cmsClient";

const fetchActiveBanners = async () => {
	const response = await cmsClient.get<IBanner[]>(
		"/homepage/admin/promotion/",
		{
			params: {
				published: true
			}
		}
	);

	return response.data;
};

interface Options {
	onSuccess?: (banners: Banner[]) => void;
}

const useActivePromotions = (options: Options = {}) => {
	const query = useQuery(["promotion-active-banners"], fetchActiveBanners, {
		select: adaptCarouselBanners,
		...options
	});

	return query;
};

export default useActivePromotions;
